import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { applySeo } from "@/lib/seo";

export function usePageSeo(pageKey: string) {
  const { data } = useQuery({
    queryKey: ["page_seo", pageKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("page_seo")
        .select("*")
        .eq("page_key", pageKey)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (!data) return;
    applySeo({
      title: data.meta_title ?? undefined,
      description: data.meta_description ?? undefined,
      keywords: data.meta_keywords ?? undefined,
      canonical: data.canonical_url ?? undefined,
      ogImage: data.og_image_url ?? undefined,
      robots: "index,follow",
    });
  }, [data]);
}
